// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_defined.js
// module id = ../../../../core-js/library/modules/_defined.js
// module chunks = 7